/**
 *   _4XS: 20,
 *
 *   _3XS: 24,
 *
 *   _2XS: 28,
 *
 *   XS: 32,
 *
 *   SM: 40,
 *
 *   MD: 48,
 *
 *   LG: 56,
 *
 *   XL: 64,
 *
 *   _2XL: 80,
 *
 *   _3XL: 100,
 *
 *   _4XL: 140,
 *
 */
export enum AvatarSize {
  _4XS = '4xs',
  _3XS = '3xs',
  _2XS = '2xs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  _2XL = '2xl',
  _3XL = '3xl',
  _4XL = '4xl',
}
